import type { CSSObject } from "@emotion/react";

/**
 * Inset (in pixels) used to float overlay drawers away from the viewport
 * edges. Matches the `MainSidebar` container padding so the drawer aligns
 * vertically with the sidebar's inner panel.
 */
export const DRAWER_FLOATING_INSET = 16;
/**
 * Returns absolute-position offsets that detach a Drawer paper from the
 * viewport edges so it sits at the same vertical level as the
 * `MainSidebar` inner panel. The drawer floats with all corners rounded.
 */
export const getFloatingDrawerOffsets = (
  anchor: "left" | "right" | "top" | "bottom" | undefined,
  inset: number = DRAWER_FLOATING_INSET
): CSSObject => {
  switch (anchor) {
    case "left":
      return {
        bottom: inset,
        height: "auto",
        left: inset,
        right: "auto",
        top: inset
      };
    case "top":
      return {
        bottom: "auto",
        left: inset,
        right: inset,
        top: inset,
        width: "auto"
      };
    case "bottom":
      return {
        bottom: inset,
        left: inset,
        right: inset,
        top: "auto",
        width: "auto"
      };
    case "right":
    default:
      return {
        bottom: inset,
        height: "auto",
        left: "auto",
        right: inset,
        top: inset
      };
  }
};
